export default "__VITE_ASSET__Bo6v8YB8__"